import { AxiosRequestConfig, AxiosStatic } from './types/index.ts';
import Axios from './core/Axios.ts';
import { extend } from './helpers/utils.ts';

function getAxios(): AxiosStatic {
  const context = new Axios();
  const axios = Axios.prototype.request.bind(context);
  extend(axios, context);
  return axios as AxiosStatic;
}

const axios = getAxios();

axios.create = function (config: AxiosRequestConfig) {
  return getAxios();
};
export default axios;
